export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
    merge: true,
  },
  {
    title: '#',
    field: 'amzPurchaseDetailCode',
    width: 100,
    align: 'center',
    visible: false,
    mergeByKey: true,
    merge: true,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 70,
    slots: { default: 'opt' },
    visible: !that.disabled,
    merge: true,
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'defaultImageUrl',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 80,
    slots: { default: 'defaultImageUrl' },
    merge: true,
  },
  {
    title: that.$l('table_label_displayName') || '产品名称',
    field: 'goodsName',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    minWidth: 220,
    slots: { default: 'displayName' },
    merge: true,
  },
  {
    title: that.$l('table_label_displayNo') || '产品编号',
    field: 'amzSkuNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    slots: { default: 'displayNo' },
    merge: true,
  },
  // {
  //   title: that.$l('table_label_sampleQty') || '样品数量',
  //   field: 'sampleQty',
  //   align: 'center',
  //   width: 100,
  //   showHeaderOverflow: true,
  //   isTotalColumn: true,
  //   formatter: ({ cellValue }) => that.format(cellValue),
  //   merge: true,
  // },
  {
    title: that.$l('table_label_demandDate') || '需求日期',
    field: 'demandDate',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_sampleType') || '样品类型',
    field: 'proofingTypeText',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_demandQty') || '样品数量',
    field: 'demandQty',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
    isTotalColumn: true,
  },
  {
    title: that.$l('table_label_demandRemark') || '交付要求',
    field: 'demandRemark',
    minWidth: 300,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
]
